module.exports = __webpack_public_path__ + "static/img/pitch_green_vertical.f961267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_green_vertical.png
// module id = Pjac
// module chunks = 94